import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { AdvancedTable } from '@/components/tables/AdvancedTable/AdvancedTable'
import { ErrorMessage } from '@/components/forms/ErrorMessage'
import { PageHeader } from '@/components/headers/PageHeader'

import { fetchOrgs } from '@/reducers/costimizer/costimizer.actions'
import {
  selectOrgs,
  selectOrgsError,
  selectOrgsLoading,
} from '@/reducers/costimizer/costimizer.redux'

import './Costimizer.scss'

const columns = [
  {
    accessor: 'name',
    label: 'Organization',
    isSearchable: true,
    format: (value, row) => (
      <Link to={`/costimizer/${row.organizationId}`} className="table-link">
        {value}
      </Link>
    ),
  },
  { accessor: 'organizationId', label: 'Org ID', isSearchable: true },
]

/**
 * Every org with Quality prompts, as a place to look one up and go to its scorecards.
 *
 * Org 1 only, and deliberately unlinked from the sidebar — reached by typing `/costimizer`.
 */
export const CostimizerPage = () => {
  const dispatch = useDispatch()
  const orgs = useSelector(selectOrgs)
  const loading = useSelector(selectOrgsLoading)
  const error = useSelector(selectOrgsError)

  useEffect(() => {
    dispatch(fetchOrgs())
  }, [dispatch])

  return (
    <>
      <PageHeader
        data-testid="costimizer-page"
        title="Costimizer"
        description="Move Quality prompts to cheaper models, one scorecard at a time"
      />

      {error && <ErrorMessage content="Could not load organizations." />}

      <AdvancedTable
        testid="costimizer-orgs-table"
        rows={orgs}
        columns={columns}
        index="organizationId"
        loading={loading}
        defaultOrderBy="name"
        defaultOrder="asc"
        pagination
        rowsPerPage={25}
        noDataHeader="No organizations found"
        noDataText="No organization has Quality prompts that could move to a cheaper model."
      />
    </>
  )
}
